import {
  Goal,
  GoalFilterDocument,
  GoalProgressCount,
  GoalSortingMode,
  ID,
  Timestamp,
  WeekDays,
} from '@griply/types';

import { sortGoals } from '../sort-goals';
import { filterGoalsByFilterDocument } from './filter-goals-by-filter-document';
import { sortGoalsHierarchically } from './sort-goals-hierarchically';

export type ProcessGoalsByFilterDocumentOptions = {
  customOrder?: ID[];
  today: Timestamp;
  weekStartsOn: WeekDays;
  taskCounts?: Map<ID, number>;
  goalProgressCounts?: Map<ID, GoalProgressCount>;
};

// Filter + order goals for the goals-overview list/timeline. `baseSortedGoals`
// is the already-sorted goal set (web/mobile `useSortedGoals`), passed through
// as both the filter input and the `allGoals` sort context. When a canonical
// custom order is present it wins (hierarchical), else fall back to sort mode.
export const processGoalsByFilterDocument = (
  baseSortedGoals: Goal[],
  filterDocument: GoalFilterDocument | undefined,
  {
    customOrder,
    today,
    weekStartsOn,
    taskCounts,
    goalProgressCounts,
  }: ProcessGoalsByFilterDocumentOptions,
): Goal[] => {
  const filtered = filterGoalsByFilterDocument(
    baseSortedGoals,
    filterDocument,
    {
      today,
      weekStartsOn,
    },
  );

  if (customOrder?.length) {
    return sortGoalsHierarchically(filtered, customOrder);
  }

  return sortGoals(filtered, {
    allGoals: baseSortedGoals,
    sortMode: filterDocument?.sortingMode ?? GoalSortingMode.StartDate,
    customOrder,
    taskCounts,
    goalProgressCounts,
  });
};
